var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x2: 0,
    y1: 47.85,
    y2: -2.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4da70e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ded46"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.891 2.712) scale(.92307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.97,
    cy: 23.07,
    r: 26,
    fill: "#68af16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.804 16.712-2.518-2.518a1.712 1.712 0 0 0-1.259-.518c-.494 0-.914.173-1.259.518L49.62 26.361l-5.444-5.463a1.714 1.714 0 0 0-1.259-.518c-.494 0-.914.173-1.259.518l-2.518 2.518a1.714 1.714 0 0 0-.518 1.259c0 .494.173.914.518 1.259l6.704 6.704 2.519 2.518a1.71 1.71 0 0 0 1.259.518c.494 0 .914-.173 1.259-.518l2.519-2.518 13.407-13.407c.345-.346.518-.766.518-1.259 0-.494-.173-.914-.518-1.259"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckMark);
export default __webpack_public_path__ + "static/media/CircleCheckMark.f0c4e15087c692c267cd630cb9275bbd.svg";
export { ForwardRef as ReactComponent };